import { createApp } from 'vue';
import WebpToGifConverter from '../Components/WebpToGifConverter.vue';

const root = document.getElementById('webp-to-gif-converter');
if (root) {
  createApp(WebpToGifConverter).mount('#webp-to-gif-converter');
}
